export function formatTrialCountdown(expiresAt: string, serverTime: string): string | null {
  const remaining = Date.parse(expiresAt) - Date.parse(serverTime)
  if (!Number.isFinite(remaining) || remaining <= 0) return null
  if (remaining < 60_000) return '<1m'
  const minutes = Math.ceil(remaining / 60_000)
  if (minutes < 60) return `${minutes}m`
  const hours = Math.ceil(minutes / 60)
  if (hours < 24) return `${hours}h`
  return `${Math.ceil(hours / 24)}d`
}
